const staticData = [
  {
    id: 1,
    image: "/burgur.jpeg",
    alt: "Narancs eukaliptusz",
    price: "NRS 300 ",
    title: "Burger",
  },
  {
    id: 2,
    image: "/chaumin.jpeg",
    alt: "Zöld tea",
    price: "NRS 200",
    title: "Chaumin",
  },
  {
    id: 3,
    image: "/pasta.jpeg",
    alt: "Thai marhahús saláta",
    price: "NRS 200",
    title: "Pasta",
  },
  {
    id: 4,
    image: "/pasta.jpeg",
    alt: "Thai marhahús saláta",
    price: "NRS 200",
    title: "Pasta",
  },
];

const orderSummary = [
  {
    id: 1,
    img: "/burgur.jpeg",
    name: "Sweatshirt for Men (Pink)",
    price: 119.99,
    quantity: 2,
    total: 239.98,
  },
  {
    id: 2,
    img: "/burgur.jpeg",
    name: "Noise Evolve Smartwatch",
    price: 94.99,
    quantity: 1,
    total: 94.99,
  },
  {
    id: 3,
    img: "/burgur.jpeg",
    name: "350 ml Glass Grocery Container",
    price: 24.99,
    quantity: 1,
    total: 24.99,
  },
];
const topCustomers = [
  {
    name: "Sandip Lamicchane",
    totalSpent: "NRS. 10,000",
    image: "/avatar-1.jpg",
  },
  { name: "John Doe", totalSpent: "NRS. 8,500", image: "/avatar-1.jpg" },
  { name: "Jane Smith", totalSpent: "NRS. 7,200", image: "/avatar-1.jpg" },
  {
    name: "Rohani Cilakar",
    totalSpent: "NRS. 66,200",
    image: "/avatar-1.jpg",
  },
  { name: "Jasmik kc", totalSpent: "NRS. 44,200", image: "/avatar-1.jpg" },
];
const topProducts = [
  { name: "Burger", totalSold: "200", image: "burgur.jpeg" },
  { name: "Chowmein", totalSold: "300", image: "chaumin.jpeg" },
  { name: "Pasta", totalSold: "250", image: "pasta.jpeg" },
];

export default staticData; // Default export
export { orderSummary }; // Named export
export { topCustomers };
export { topProducts };
